
import React, { ReactHTMLElement, useContext, useEffect, useState, useRef, FormEvent } from "react";
import { BasicContext } from '../context/BasicContext'
import WebServiceContext from "../WebService/ServiceContext";
import HibSnakeBox from './HibSnakeBox'

type FileUploaderProp = {
    cardData: CardProps
    complete: () => {} | void
}

type UploadResult = {
    Result: string
    fileName: string
}

const toBase64 = (file: Blob): Promise<string> => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = error => reject(error);
});

/**
 * 
 _toBase64(event.target.files[0]).then(file64 => {
                    base64Data = file64;
                    //開啟上傳按鈕
                    uploadMyFileBtn.disabled = false;
                    _modal.querySelector(".custom-file-label").innerHTML = event.target.files[0].name;
                });
 */

export default (props: FileUploaderProp) => {
    const ws = useContext(WebServiceContext)
    const bc = useContext(BasicContext)
    const [queen, setQueen] = useState<"ready"|"start"|"complete">("ready")
    const inputRef = useRef<HTMLInputElement>(null)
    const [file64, setFile64] = useState<string | null>(null)
    const [fileType, setFileType] = useState<"pdf"|"jpg"|"png">("png")
    const [resFileName, setResFileName] = useState<string | null>(null)
    const snakeBoxRef = useRef<SnakeBoxHandle>(null)

    /*
    useEffect(() => {
        console.log(props)
        setResFileName(props.cardData.ResFileName)
    }, [props])
    */

    useEffect(() => {
        setResFileName(props.cardData.ResFileName)
        return
    }, [props.cardData.ResFileName])

   

    /*
    const closePanel = () => {
        setOpen(false)
    }
    
    const fileUploaderHandler = () => {
        setOpen(true)
    }
    */


    const uploadFile = () => {
        setQueen("start")
        if (file64) {
            ws.WebService.RegFileUpload(props.cardData.ActID, file64).then((res) => {
                console.log(res)
                const _r = res as UploadResult
                if (_r.Result == "OK") {
                    /*return ws.webservice.doApplyCourse(
                        props.cardData.ActID,
                        (
                            (props.cardData.regState == 10 && props.cardData.StateDefault == "N") ? "Y" :
                                props.cardData.StateDefault == "N" ? "N" :
                                    "Y"
                        )
                    )*/
                    setResFileName(_r.fileName)
                    setFile64(null)

                    setTimeout(() => {
                        setQueen("complete")
                    }, 1000);
                    setTimeout(() => {
                        setQueen("ready")
                    }, 3000);

                    snakeBoxRef.current?.launch()

                    
                    return
                } else {
                    alert("上傳失敗")
                }
            }).then(() => {
                props.complete()
            })
        } else {
            alert("file64 not set")
        }
    }

    useEffect(() => {
        if(file64){
            uploadFile()
        }
    }, [file64])

    return (
        <>
            <div style={{ display: "flex", flexDirection: "column" }}>
                {/*
            <p>
                    props.cardData.ResFileName ?
                        "重新上傳檔案並報名" :
                        "上傳檔案並報名"
            </p>
            */}
                {
                    resFileName && queen == "ready" &&
                    <button
                        className="hibBtn main large"
                        onClick={() => {
                            props.cardData &&
                                ws.WebService.RegFileDownload(resFileName).then(res => {
                                    console.log(res)
                                    if (props.cardData) {
                                        const ext = resFileName.split(".")[1]
                                        const a = document.createElement("a"); //Create <a>
                                        switch (ext.toLowerCase()) {
                                            case "pdf":
                                                a.href = "Data:application/pdf;base64," + res; //Image Base64 Goes here
                                                break
                                            case "jpg":
                                                a.href = "data:image/jpg;base64," + res; //Image Base64 Goes here
                                                break
                                            case "png":
                                                a.href = "data:image/png;base64," + res; //Image Base64 Goes here
                                                break
                                        }
                                        a.download =resFileName; //File name Here
                                        a.click();
                                    }
                                })
                        }}>
                        下載前次上傳的資料
                    </button>
                }
                {
                    queen == "ready" ?
                    <>
                        <label
                            className="hibBtn large main upload"
                        >
                            <img src="./images/course/upload.svg"/>
                            <input
                                type="file"
                                ref={inputRef}
                                onChange={(event: FormEvent<HTMLInputElement>) => {
                                    const _f: HTMLInputElement = event.target as HTMLInputElement
                                    if (_f.files) {                                                                  
                                        const ext = _f.files[0].name.split(".")[_f.files[0].name.split(".").length-1]             
                                        ext.toLowerCase() == "pdf" ? setFileType("pdf"):
                                        ext.toLowerCase() == "jpg" ? setFileType("jpg"):
                                        ext.toLowerCase() == "png" ? setFileType("png"):null
                                        
                                        toBase64(_f.files[0]).then((file64: string) => {
                                            setFile64(file64)
                                        })
                                                    
                                        /*  
                                        toBase64(_f.files[0]).then((file64: string) => {
                                            uploadFile()
                                        })*/
                                    }

                                }}
                            />
                            {
                                props.cardData.ResFileName ?
                                    "重新上傳檔案" :
                                    "上傳檔案"
                            }
                        </label>
                        {/*
                        
                        <button
                            className="hibBtn main"
                            disabled={file64 == null}
                            onClick={uploadFile}
                        >{
                                props.cardData.ResFileName ?
                                    "重新上傳檔案" :
                                    "上傳檔案"
                        }</button>
                         */}
                    </>:
                    queen == "start" ?
                    <div className="uploading">
                        <img 
                            className="uploadArrow" 
                            src={
                                fileType=="pdf"?
                                "./images/course/arrow_pdf.svg":
                                fileType=="jpg"?
                                "./images/course/arrow_jpg.svg":
                                fileType=="png"?
                                "./images/course/arrow_png.svg":""
                            }
                            />
                        <p className="txt">
                            檔案上傳中，請稍後
                        </p>
                    </div>:
                    queen == "complete"? 
                    <div className="uploadComplete">
                        <img 
                            className="uploadArrow"
                            src="./images/course/uploadComplete.svg"
                        />
                         <p className="txt">
                            檔案上傳完成
                        </p>
                    </div>:
                    ""
                }
            </div>
           
        </>
    )
}

